<template>
    <div v-if="items && items.length > 0" :class="(mobileState && swiper)?'t-swipper': 't-promo-course'">
        <template v-if="mobileState && swiper" class="">
            <swiper class="t-promo-course" :options="swiperOption_mobile">
                <swiper-slide v-for="(course, index) in items" :key="'course-'+index" class="t-promo-course__item">
                    <h3 class="t-promo-course__item-title">{{ text.title }}</h3>
                    <cmp-course class="t-courseItem_single" :data="course"></cmp-course>
                </swiper-slide>
            </swiper>
            <div class="t-swipper__pagination" :class="[paginatorClass,  {'_flex-start':(items.length > 5)}]"></div>
        </template>
        <template v-else>
            <div v-for="(course, index) in items" :key="'course-'+index" class="t-promo-course__item">
                <h3 class="t-promo-course__item-title">{{ text.title }}</h3>
                <cmp-course class="t-courseItem_single" :data="course"></cmp-course>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    import Course from './Course.vue'

    export default {
        props: {
            text: { 
                type: Object,
                default: function () {
                    return {
                        title: 'Рекомендуемый курс'
                    }
                }
            },
            swiper: { 
                type: Boolean,
                default: true
            },
            items: {
                type: Array,
            }
        },
        data() {
            return {
                paginatorClass: 'js-pagination_courses-' + this.$route.name
            }
        },        
        components: {
            'cmp-course': Course,
        },
        computed: {
            ...mapGetters(['mobileState']),
            ...mapGetters('standartObjects', ['swiperOption']),
            swiperOption_mobile(){ 
                return this.swiperOption('.'+this.paginatorClass)
            },
        },
        methods: {
            ...mapActions('profile', ['LoadDocuments']),
        }
    }
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// src/vue_components/PromoCourses.vue